// extracted by mini-css-extract-plugin
module.exports = {"invalid-input":"hook_invalid-input__2tAS0","valid-input":"hook_valid-input__31Mdb","m-1":"hook_m-1__1hUR0"};